<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: #405950" class="font-weight-bold">
          {{ $t("SIDENAV.settings.general") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: #405950">
          <i
            :class="
              $i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'
            "
          ></i>
        </v-btn>
      </div>
    </div>
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- VAT Rate -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.Package VAT rate')"
            v-model.trim="data.package_vat"
            step="0.01"
            min="0"
            max="100"
          />

          <!-- App Commission Rate -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.Commission percentage from the center')"
            v-model.trim="data.commission_center"
            step="0.01"
            min="0"
            max="100"
          />

          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.Store VAT Rate')"
            v-model.trim="data.store_vat"
            min="0"
          />

          <!-- Cancellation Penalty Amount (SAR) -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.VAT rate for the activity')"
            v-model.trim="data.festival_vat"
            step="0.01"
            min="0"
          />

          <!-- Payment Confirmation Duration -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.Delivery price within Abha city')"
            v-model.trim="data.delivery_price_inside_abha"
            min="0"
          />

          <!-- Group Session Discount (SAR) -->
          <base-input
            type="number"
            col="6"
            :placeholder="$t('MESSAGES.Delivery price outside Abha city')"
            v-model.trim="data.delivery_price_outside_abha"
            step="0.01"
            min="0"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetting",
  data() {
    return {
      isWaitingRequest: false,
      data: {
        package_vat: null,
        commission_center: null,
        store_vat: null,
        festival_vat: null,
        delivery_price_inside_abha: null,
        delivery_price_outside_abha: null,
      },
    };
  },
  methods: {
    async getDataToEdit() {
      try {
        let res = await this.$axios.get("settings?key=general-settings");
        const settings = res.data.data.data[0].value;
        this.data.package_vat = settings.package_vat;
        this.data.commission_center = settings.commission_center;
        this.data.store_vat = settings.store_vat;
        this.data.festival_vat = settings.festival_vat;
        this.data.delivery_price_inside_abha =
          settings.delivery_price_inside_abha;
        this.data.delivery_price_outside_abha =
          settings.delivery_price_outside_abha;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "general-settings");

      // Append all form data
      REQUEST_DATA.append("value[package_vat]", this.data.package_vat);
      REQUEST_DATA.append(
        "value[commission_center]",
        this.data.commission_center
      );
      REQUEST_DATA.append("value[store_vat]", this.data.store_vat);
      REQUEST_DATA.append("value[festival_vat]", this.data.festival_vat);
      REQUEST_DATA.append(
        "value[delivery_price_inside_abha]",
        this.data.delivery_price_inside_abha
      );
      REQUEST_DATA.append(
        "value[delivery_price_outside_abha]",
        this.data.delivery_price_outside_abha
      );

      try {
        await this.$axios.post("settings", REQUEST_DATA);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    validateFormInputs() {
      this.submitForm();
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>
